module.exports = __webpack_public_path__ + "static/media/elevation.e6918076.png";